/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Stefano Tognon';
  const content = 'Executive General Manager, Enterprise Growth Division';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Stefano Tognon'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/stefano-tognon-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Stefano was appointed Executive General Manager, Enterprise Growth
            Division in February 2026.
            <br />
            <br />
            He joined Latitude in March 2022 to lead Corporate Strategy and
            Development, was appointed Group Treasurer in November 2023 and
            served as acting CFO from January to June 2025.
            <br />
            <br />
            Prior to Latitude, Stefano spent 15 years at J.P. Morgan Chase
            covering Financial Institution clients across North America,
            Australia, APAC and Europe. During his tenure at J.P. Morgan in New
            York, Stefano specifically focused on the Specialty Finance and
            Alternative Asset Management sectors across M&A, Debt & Equity
            Capital Markets.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Stefano holds a Master’s degree in Finance and a Bachelor’s degree
            in Business Administration from L. Bocconi University in Milan,
            Italy.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
